export class GcpGcsResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "locationType",
            "baseName": "locationType",
            "type": "GcsLocationType",
            "format": ""
        },
        {
            "name": "constituentRegions",
            "baseName": "constituentRegions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpGcsResource.attributeTypeMap;
    }
    constructor() {
    }
}
